var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar021(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.6408 14.6201V14.0316C24.6408 12.0495 24.6408 10.4608 24.5511 9.16846H2.95496C2.86523 10.4608 2.86523 12.0495 2.86523 14.0316V14.6201C2.86523 19.6139 2.86523 22.1109 4.30027 23.6622C5.7353 25.2136 8.04495 25.2136 12.6643 25.2136H14.8418C19.4611 25.2136 21.7708 25.2136 23.2058 23.6622C24.6408 22.1109 24.6408 19.6139 24.6408 14.6201Z",
    fill: "url(#paint0_linear_4930_7619)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6071 14.0395C12.1324 14.0395 11.7476 14.4244 11.7476 14.8991C11.7476 15.3738 12.1324 15.7587 12.6071 15.7587H18.3376C18.8123 15.7587 19.1971 15.3738 19.1971 14.8991C19.1971 14.4244 18.8123 14.0395 18.3376 14.0395H12.6071Z",
    fill: "url(#paint1_linear_4930_7619)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16889 14.0395C8.69416 14.0395 8.30932 14.4244 8.30932 14.8991C8.30932 15.3738 8.69416 15.7587 9.16889 15.7587H9.17918C9.6539 15.7587 10.0387 15.3738 10.0387 14.8991C10.0387 14.4244 9.6539 14.0395 9.17918 14.0395H9.16889Z",
    fill: "url(#paint2_linear_4930_7619)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16889 18.6239C8.69416 18.6239 8.30932 19.0087 8.30932 19.4834C8.30932 19.9582 8.69416 20.343 9.16889 20.343H14.8993C15.374 20.343 15.7589 19.9582 15.7589 19.4834C15.7589 19.0087 15.374 18.6239 14.8993 18.6239H9.16889Z",
    fill: "url(#paint3_linear_4930_7619)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3273 18.6239C17.8525 18.6239 17.4677 19.0087 17.4677 19.4834C17.4677 19.9582 17.8525 20.343 18.3273 20.343H18.3376C18.8123 20.343 19.1971 19.9582 19.1971 19.4834C19.1971 19.0087 18.8123 18.6239 18.3376 18.6239H18.3273Z",
    fill: "url(#paint4_linear_4930_7619)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73628 2.29218C7.73628 1.81746 7.35144 1.43262 6.87672 1.43262C6.40199 1.43262 6.01715 1.81746 6.01715 2.29218V3.0197C5.09483 3.28111 4.31694 3.70599 3.66945 4.40597C2.7779 5.36981 2.3816 6.58762 2.19181 8.11373C2.00584 9.60913 2.00585 11.5256 2.00586 13.9708V14.6813C2.00585 17.1266 2.00584 19.043 2.19181 20.5384C2.3816 22.0645 2.7779 23.2823 3.66945 24.2462C4.56982 25.2195 5.72234 25.6609 7.16471 25.8706C8.56068 26.0735 10.3443 26.0735 12.5948 26.0734H14.9116C17.1622 26.0735 18.9458 26.0735 20.3417 25.8706C21.7841 25.6609 22.9366 25.2195 23.837 24.2462C24.7285 23.2823 25.1248 22.0645 25.3146 20.5384C25.5006 19.043 25.5006 17.1265 25.5006 14.6813V13.9709C25.5006 11.5256 25.5006 9.60914 25.3146 8.11373C25.1248 6.58762 24.7285 5.36981 23.837 4.40597C23.1895 3.70599 22.4116 3.28111 21.4893 3.0197V2.29218C21.4893 1.81746 21.1045 1.43262 20.6297 1.43262C20.155 1.43262 19.7702 1.81746 19.7702 2.29218V2.71153C18.4681 2.57867 16.866 2.57868 14.9116 2.5787H12.5948C10.6405 2.57868 9.0383 2.57867 7.73628 2.71153V2.29218ZM4.93146 5.57333C5.22869 5.25201 5.58312 5.006 6.04993 4.82026C6.15247 5.18028 6.48381 5.44391 6.87672 5.44391C7.35144 5.44391 7.73628 5.05907 7.73628 4.58435V4.44061C8.95228 4.29961 10.524 4.29783 12.6644 4.29783H14.842C16.9825 4.29783 18.5542 4.29961 19.7702 4.44061V4.58435C19.7702 5.05907 20.155 5.44391 20.6297 5.44391C21.0226 5.44391 21.354 5.18029 21.4565 4.82027C21.9233 5.00601 22.2778 5.25201 22.575 5.57333C23.1162 6.15846 23.437 6.96059 23.6066 8.30912H3.89989C4.06941 6.96059 4.39022 6.15846 4.93146 5.57333ZM3.76959 10.0282C3.72561 11.1249 3.72499 12.4359 3.72499 14.0318V14.6203C3.72499 17.1398 3.72655 18.9493 3.89779 20.3262C4.06676 21.6849 4.38798 22.4912 4.93146 23.0788C5.46613 23.6568 6.18595 23.9911 7.41199 24.1693C8.67006 24.3522 10.3286 24.3543 12.6644 24.3543H14.842C17.1779 24.3543 18.8364 24.3522 20.0945 24.1693C21.3205 23.9911 22.0403 23.6568 22.575 23.0788C23.1185 22.4912 23.4397 21.6849 23.6087 20.3262C23.7799 18.9493 23.7815 17.1398 23.7815 14.6203V14.0318C23.7815 12.4359 23.7808 11.1249 23.7369 10.0282H3.76959Z",
    fill: "url(#paint5_linear_4930_7619)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4930_7619",
    x1: 13.753,
    y1: 9.16846,
    x2: 13.753,
    y2: 25.2136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4930_7619",
    x1: 13.7532,
    y1: 1.43262,
    x2: 13.7532,
    y2: 26.0734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4930_7619",
    x1: 13.7532,
    y1: 1.43262,
    x2: 13.7532,
    y2: 26.0734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4930_7619",
    x1: 13.7532,
    y1: 1.43262,
    x2: 13.7532,
    y2: 26.0734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4930_7619",
    x1: 13.7532,
    y1: 1.43262,
    x2: 13.7532,
    y2: 26.0734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4930_7619",
    x1: 13.7532,
    y1: 1.43262,
    x2: 13.7532,
    y2: 26.0734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar021);
export default __webpack_public_path__ + "static/media/calendar-02-1.85635d1dece2eac3d0d8b8fb6034608a.svg";
export { ForwardRef as ReactComponent };